import { Recipe, Grocery } from "./model";
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { combineReducers } from 'redux';

export type RecipeState = {
  readonly recipes: Recipe[];
  readonly activeRecipe: string;
  readonly isFetchingRecipes: boolean;
  readonly groceries: Grocery[];
}

export type RecipeAction = ActionType<typeof actions>;

export default combineReducers<RecipeState, RecipeAction>({
  recipes: (state = [], action) => {
    switch (action.type) {
      case getType(actions.add):
        const newRecipe: Recipe = action.payload;
        const localRecipe = state.find(recipe => recipe.id === newRecipe.id);
        if (localRecipe) {
          state[state.indexOf(localRecipe)] = newRecipe;
          return state;
        } else {
          return [...state, newRecipe];
        }
      case getType(actions.update):
        const updatedRecipe: Recipe = action.payload;
        if (updatedRecipe.id === undefined) { return state };
        const stateRecipeIndex = state.findIndex(recipe => recipe.id === updatedRecipe.id)
        state[stateRecipeIndex] = updatedRecipe
      default:
        return state;
    }
  },
  activeRecipe: (state = '', action) => {
    switch (action.type) {
      case getType(actions.setActiveRecipe):
        return action.payload;
      case getType(actions.unSetActiveRecipe):
        return '';
      default:
        return state;
    }
  },
  isFetchingRecipes: (state = false, action) => {
    switch (action.type) {
      case getType(actions.fetchRecipe.request):
        return true;
      case getType(actions.fetchRecipe.success), getType(actions.fetchRecipe.failure):
        return false;
      default:
        return state;
    }
  },
  groceries: (state = [], action) => {
    switch (action.type) {
      case getType(actions.addGroceryList):
        return action.payload;
      default:
        return state;
    }
  }
})